// extracted by mini-css-extract-plugin
export var quillEditor = "_py-1";
export var variable = "_py-0";